import { render } from "./5577e2fc-815f-11eb-811b-00155d01060e.vue?vue&type=template&id=6b47774a"
import script from "./5577e2fc-815f-11eb-811b-00155d01060e.vue?vue&type=script&lang=js"
export * from "./5577e2fc-815f-11eb-811b-00155d01060e.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__